import React from 'react';
import * as styles from './style';

const OrderItemPlaceholder = () => {
  return (
    <styles.OrderItemContainer>
      <styles.OrderItemContent>
        <styles.BackgroundAnimation />
        <styles.DescribeBackgroundAnimation />
      </styles.OrderItemContent>
      <styles.OrderItemClient>
        <styles.BackgroundAnimation />
        <styles.DescribeBackgroundAnimation />
      </styles.OrderItemClient>
      <styles.OrderItemArea>
        <styles.BackgroundAnimation />
        <styles.DescribeBackgroundAnimation />
      </styles.OrderItemArea>
    </styles.OrderItemContainer>
  );
};

export default OrderItemPlaceholder;


// WEBPACK FOOTER //
// ./src/components/OrderItemPlaceholder/index.js